export const AI = 'ai';
export const CALENDAR_VIEW = 'calendarView';
export const CONNECTION = 'connection';
export const DEV_SANDBOX = 'devSandbox';
export const DOCS = 'docs';
export const ESTIMATE = 'estimate';
export const MAPPING = 'mapping';
export const MATCHING = 'matching';
export const MIGRATION = 'migration';
export const MONDAY = 'monday';
export const REPLICATOR = 'replicator';
export const WORKSPACE = 'workspace';
